/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function CodeCommitIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M20 27c2.5 0 4.75-1.312 6-3.5 1.313-2.125 1.313-4.812 0-7-1.25-2.125-3.5-3.5-6-3.5-2.562 0-4.812 1.375-6.062 3.5-1.313 2.188-1.313 4.875 0 7 1.25 2.188 3.5 3.5 6.062 3.5m9.875-5.5C29.125 26.313 25 30 20 30a10.034 10.034 0 0 1-9.937-8.5H1.5C.625 21.5 0 20.875 0 20c0-.812.625-1.5 1.5-1.5h8.563c.75-4.812 4.874-8.5 9.937-8.5 5 0 9.125 3.688 9.875 8.5H38.5c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5z"/>}
        </IconWrapper>);
}
